import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldMemoModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  maxLength: number;
  value: string;
}

export class FieldMemoModel extends BaseFieldModel implements IFieldMemoModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public maxLength: number,
    public value: string,
  ) {
    super(isRequired, isReadOnly);
  }
}
